//import 
const uuid = require('uuid');
import * as ComponentsDb from '@/edit/tree/componentsdb.js';
import Treeutil from '@/edit/tree/treeutil.js';
import { sortBy, groupBy } from 'lodash';

function RecommendationBuilder(partutil, title, description) {
  this.treeutil = new Treeutil(partutil.from);
  this.mainComponents = [];
  this.mainLinks = [];
  this.partutil = partutil;
  this.title = title;
  this.description = description;
  this.components = [];
  this.links = [];

}
RecommendationBuilder.prototype.addComponent = function (componentType, extra, linkData = {name:'link'}) {
  let newComponent = ComponentsDb.createComponent(componentType);
  Object.assign(newComponent, extra);
  newComponent.id = uuid.v4();
  this.mainComponents.push(newComponent);
  this.mainLinks.push(linkData);
  this.components.push(newComponent);

  this.lastComponent = newComponent;


  return this;
}
RecommendationBuilder.prototype.linkPreviousComponent = function (linkData, componentType, extra) {
  let newComponent = ComponentsDb.createComponent(componentType);
  Object.assign(newComponent, extra);
  newComponent.id = uuid.v4();
  const link = this.treeutil.addLink(linkData, this.lastComponent, newComponent);
  this.links.push(link);
}

RecommendationBuilder.prototype.build = function () {
  const {title, description, mainComponents, mainLinks, links, components} = this;
  return {
    links,
    components,
    title,
    description,
    mainComponents,
    mainLinks
  }
}


const notZero = function (val) {
  return val;
}

const MOVE_RIGHT = {dx:3,dy:0 }
const MOVE_LEFT = {dx:-3,dy:0 }
const MOVE_UP = {dx:0,dy:-3 }
const MOVE_DOWN = {dx:0,dy:3 }

function Recommender(partutil, gamedata) {
  this.partutil = partutil;
  this.gamedata = gamedata;
  this.RECOMMENDATIONS = [
    [
      new RecommendationBuilder(
        this.partutil,
        "Add an Animation",
        "Fade in"
      )
      .addComponent('tween', {tweens:[
        {
          name: 'Fade In',
          property: 'alpha',
          from: 0,
          to: 1,
          tween: 'easeInCubic'
        },
        {
          name: 'Zoom In',
          property: 'scalebothglobal',
          from: 0,
          to: 1,
          tween: 'easeOutQuad'
        },
      ]})
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links) {
        const factor = (['sprite', 'text'].includes(forComponent.type) ? 1 : 0);
        const tweenAdded = (Object.values(myComponentsByType).filter(notZero).length > 2 ? true : (myComponentsByType.tween.length > 0));
        return factor * (components.length === 1 ? 100 : (tweenAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move right",
      )
      .addComponent('move', MOVE_RIGHT)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['sprite', 'text'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move left",
      )
      .addComponent('move', MOVE_LEFT)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['sprite', 'text'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move up",
      )
      .addComponent('move', MOVE_UP)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['sprite', 'text'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move down",
      )
      .addComponent('move', MOVE_DOWN)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['sprite', 'text'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move right",
      )
      .addComponent('move', MOVE_RIGHT, {name:'finish'}
)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['move'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move left",
      )
      .addComponent('move', MOVE_LEFT, {name:'finish'}
)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['move'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move up",
      )
      .addComponent('move', MOVE_UP, {name:'finish'}
)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['move'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Make it move!",
        "Move down",
      )
      .addComponent('move', MOVE_DOWN, {name:'finish'}
)
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender, {fromLinks, fromComponents}) {
        const factor = (['move'].includes(forComponent.type) ? 1 : 0);
        const moveAdded = fromComponents.map( ({type}) => { return type}).includes('move');
        return factor * (components.length === 1 ? 100 : (moveAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Bulge",
        "Make it bulge when the move is finished"
      )
      .addComponent('tween', {flip:true,time:0.1,tweens:[
        {
          name: 'Zoom In',
          property: 'scalebothglobal',
          from: 1,
          to: 1.3,
          tween: 'easeOutQuad'
        }
      ]}, {name:'finish'}
      )
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, in_components, in_links, recommender) {
        return 0;
        const factor = (forComponent.type === 'move' ? 1 : 0);
        const {components} = partutil.findComponentsAndLinksFrom(forComponent);
        const tweenAdded = myComponentsByType.tween.length > 0;

        return factor * (components.length === 1 ? 100 : (tweenAdded ? 0 : 100))
      }
    ],
    [
      new RecommendationBuilder(
        this.partutil,
        "Move Up",
        "Make it move up when the move is finished."
      )
      .addComponent('move', {dx:0,dy:-5}, {name:'finish'}
      )
      .build(),
      function rank(forComponent, componentsByType, myComponentsByType, components, links, recommender) {
        return 0;
        const factor = (forComponent.type === 'move' ? 1 : 0);
        const movesAdded = myComponentsByType.move.length >= 2;

        return factor * (components.length === 1 ? 100 : (movesAdded ? 0 : 100))
      }
    ]

  ]
}

Recommender.prototype.getComponentsByType = function (components) {
  const componentsByType = groupBy(components, 'type');
  ComponentsDb.typeList.forEach( ({type}) => {
    if (typeof(componentsByType[type]) === 'undefined') {
      componentsByType[type] = 0;
    }
  });
  return componentsByType;
}

Recommender.prototype.scoreRecommendations = function (forComponent, transformComponentsAndLinks, partutil) {
  if (!transformComponentsAndLinks) {
    return [];
  }
  const myComponentsAndLinks = this.partutil.findComponentsAndLinksFrom(forComponent);
  const componentsByType = this.getComponentsByType(transformComponentsAndLinks.components);
  const myComponentsByType = this.getComponentsByType(myComponentsAndLinks.components);
  let {links: fromLinks, components: fromComponents} = this.partutil.findComponentsAndLinksFrom(forComponent);
  fromComponents = fromComponents.filter( ({id}) => { return forComponent.id !== id } );

  return sortBy(this.RECOMMENDATIONS.map( ([recommendation, ranker]) => {
    const score = ranker(forComponent, componentsByType, myComponentsByType, this.partutil.from.components, this.partutil.from.links, this, {fromLinks, fromComponents});
    return {
      recommendation,
      score
    }
  }), 'score')
}
Recommender.prototype.getRecommendations = function (transform, forComponent) {
  const transformComponent = this.partutil.findComponentForTransform(transform);
  const linksComponentsForTransform = this.partutil.findComponentsAndLinksFrom(transformComponent);
  const recommendations = this.scoreRecommendations(forComponent, linksComponentsForTransform, this.partutil);
  return recommendations.filter( ({score}) => {
    return score > 0;
  }).slice(0,5);

}
Recommender.prototype.addRecommendationTo = function (recommendation, transform, component) {
  const treeutil = new Treeutil(this.partutil.from);
  // first add the top level components
  let addedComponents = [];
  let addedLinks = [];
  recommendation.mainComponents.forEach( (newComponent,i) => {
    const linkData = recommendation.mainLinks[i];
    const {addedComponents: newAddedC,addedLinks: newAddedL} = treeutil.addComponentWithLinkData(component, linkData, newComponent);
    addedComponents = addedComponents.concat(newAddedC);
    addedLinks = addedLinks.concat(newAddedL);
  });
  return {addedComponents,addedLinks}
}
Recommender.prototype.getLinkRecommendations = function (transform, forComponent) {
  //ComponentsDb.types[forComponent.type].slots
  const links = ComponentsDb.createSlots(forComponent, this.partutil, transform);
  return links;
}
export default Recommender;
